import React, {useState} from 'react';
import {Button, Text, TextInput} from '@gravity-ui/uikit';
import styles from './PasswordAuth.module.scss';
import {Eye, EyeSlash} from '@gravity-ui/icons';
import {usePasswordForm} from '../../model';
import classNames from 'classnames';

export const PasswordAuth = () => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [inputType, setInputType] = useState<'password' | 'text'>('password');

  const {values, errors, handleChange, touched, handleBlur, handleSubmit, errorMessage} = usePasswordForm();

  const handleToggle = () => {
    setShowPassword(!showPassword);
    setInputType(showPassword ? 'password' : 'text');
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.inputWrapper}>
        <TextInput
          type={inputType}
          name="password"
          placeholder="Пароль"
          size="xl"
          onKeyDown={handleInputKeyDown}
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          autoFocus
          endContent={
            <span
              onClick={handleToggle}
              className={classNames(styles.icon, {[styles.iconWithError]: touched.password && errors.password})}>
              {showPassword ? <Eye /> : <EyeSlash />}
            </span>
          }
          errorMessage={touched.password && errors.password}
          error={Boolean((touched.password && errors.password) || errorMessage)}
          errorPlacement={errors.password ? 'inside' : 'outside'}
        />
        {errorMessage && (
          <Text variant={'body-1'} color={'danger'}>
            {errorMessage}
          </Text>
        )}
      </div>

      <Button view="action" size="xl" width="max" type="submit" className={styles.submitButton}>
        Войти
      </Button>
      <Button view={'flat'} size={'xs'}>
        Забыли пароль?
      </Button>
    </form>
  );
};
